import axios from 'axios'
import { STOCKS_ENDPOINT } from '../../endpoints'

export async function deleteStock(id) {
  const response = await axios.delete(`${STOCKS_ENDPOINT}/${id}`)
  return response
}
